var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-sheet',[_c('v-container',[_c('tickets-create'),_vm._v(" "),_c('tickets-datatable')],1)],1),_vm._v(" "),_c('tickets-listener')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }